import { MapperBase } from '../../utilities/mapper-base';
import { CaseWithDocCountResource } from '../resource/case-with-doc-count.resource';
import { Case } from '../ui/case.model';

export class CaseWithDocCountResourceToCaseMapper extends MapperBase<CaseWithDocCountResource, Case> {
	map(source: CaseWithDocCountResource): Case {
		const dest = new Case();
		dest.id = source?.caseId;
		dest.name = source?.caseName;
		dest.documentCount = source?.docCount;
		dest.indexDocCount = source?.indexDocCount;
		return dest;
	}
}
